import React, { useState, useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Navbar from "../shared/navbar/Navbar";
import Sidebar from "../shared/sidebar/Sidebar";
import "react-toastify/dist/ReactToastify.css";

function Layout() {
  const [active, setActive] = useState(false);
  const [pathName, setPathName] = useState<string[]>();
  let location = useLocation();

  function handleNavToggle() {
    setActive((oldState) => !oldState);
  }

  useEffect(() => {
    setPathName(
      location.pathname
        .split("/")
        .filter((item) => item)
        .map((item) => item.split("-").join(" "))
    );
  }, [location]);

  // hide the sideNav on route change
  useEffect(() => {
    setActive(false);
  }, [location.pathname]);

  return (
    <div className="relative">
      {/* <div className="absolute top-[13.5rem] left-2 text-white w-1/2 right-0 mx-4 md:ml-[25rem] md:mr-6 -mt-36 p-0">
                <span>
                    {
                        pathName?.map(path => (
                            <span className='text-gray-200' key={path} >
                                <span className='capitalize font-medium'>
                                    {path}
                                </span>
                                <span> / </span>
                            </span>
                        ))
                    }
                </span>
            </div> */}
      <Navbar adminPage={false} />
      <div className="flex flex-row">
        <div className="absolute top-10 left-7">
          <button
            onClick={handleNavToggle}
            className="text-white bg-gray-900/20 rounded-full w-11 h-11 flex items-center justify-center p-1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5"
              />
            </svg>
          </button>
        </div>
        {active && (
          <div
            onClick={() => setActive(false)}
            className="fixed inset-0 bg-black bg-opacity-25 z-10"
          />
        )}
        <div
          className={`${active
            ? "translate-x-0 fixed top-4"
            : "-translate-x-[150%] top-4 fixed"
            } md:block md:fixed md:translate-x-0 md:top-4 w-[19rem] transition-all duration-500 z-[100]`}
        >
          <Sidebar />
        </div>
      </div>

      <div>
        <div className="h-[84vh] overflow-hidden custom-scroll-container overflow-y-auto bg-white text-gray-800 shadow-xl rounded-2xl mx-4 md:ml-[25rem] md:mr-6 -mt-36 p-6 md:p-10 mb-4">
          <Outlet />
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      </div>
    </div>
  );
}

export default Layout;
